/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListUnproxiedMcpServersSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListUnproxiedMcpServersSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListUnproxiedMcpServersSecurity = {
  option1?: ListUnproxiedMcpServersSecurityOption1 | undefined;
  option2?: ListUnproxiedMcpServersSecurityOption2 | undefined;
};

export type ListUnproxiedMcpServersRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListUnproxiedMcpServersSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListUnproxiedMcpServersSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListUnproxiedMcpServersSecurityOption1$Outbound,
    ListUnproxiedMcpServersSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listUnproxiedMcpServersSecurityOption1ToJSON(
  listUnproxiedMcpServersSecurityOption1:
    ListUnproxiedMcpServersSecurityOption1,
): string {
  return JSON.stringify(
    ListUnproxiedMcpServersSecurityOption1$outboundSchema.parse(
      listUnproxiedMcpServersSecurityOption1,
    ),
  );
}

/** @internal */
export type ListUnproxiedMcpServersSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListUnproxiedMcpServersSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListUnproxiedMcpServersSecurityOption2$Outbound,
    ListUnproxiedMcpServersSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listUnproxiedMcpServersSecurityOption2ToJSON(
  listUnproxiedMcpServersSecurityOption2:
    ListUnproxiedMcpServersSecurityOption2,
): string {
  return JSON.stringify(
    ListUnproxiedMcpServersSecurityOption2$outboundSchema.parse(
      listUnproxiedMcpServersSecurityOption2,
    ),
  );
}

/** @internal */
export type ListUnproxiedMcpServersSecurity$Outbound = {
  Option1?: ListUnproxiedMcpServersSecurityOption1$Outbound | undefined;
  Option2?: ListUnproxiedMcpServersSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListUnproxiedMcpServersSecurity$outboundSchema: z.ZodMiniType<
  ListUnproxiedMcpServersSecurity$Outbound,
  ListUnproxiedMcpServersSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListUnproxiedMcpServersSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListUnproxiedMcpServersSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listUnproxiedMcpServersSecurityToJSON(
  listUnproxiedMcpServersSecurity: ListUnproxiedMcpServersSecurity,
): string {
  return JSON.stringify(
    ListUnproxiedMcpServersSecurity$outboundSchema.parse(
      listUnproxiedMcpServersSecurity,
    ),
  );
}

/** @internal */
export type ListUnproxiedMcpServersRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListUnproxiedMcpServersRequest$outboundSchema: z.ZodMiniType<
  ListUnproxiedMcpServersRequest$Outbound,
  ListUnproxiedMcpServersRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listUnproxiedMcpServersRequestToJSON(
  listUnproxiedMcpServersRequest: ListUnproxiedMcpServersRequest,
): string {
  return JSON.stringify(
    ListUnproxiedMcpServersRequest$outboundSchema.parse(
      listUnproxiedMcpServersRequest,
    ),
  );
}
